"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transparent = exports.normal = exports["default"] = void 0;
/**
 * Page field style modes
 *
 * Used to to determine how a field
 * should be presented on the form.
 */
var normal = exports.normal = 'normal';
var transparent = exports.transparent = 'transparent';
var _default = exports["default"] = {
  normal: normal,
  transparent: transparent
};